// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//     user: null,
//     token: localStorage.getItem('authToken') || null,
//     isAuthenticated: !!localStorage.getItem('authToken'),
//     loading: false,
//     error: null,
// };

// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//     reducers: {
//         setUser: (state, action) => {
//             state.user = action.payload;
//             state.isAuthenticated = true;
//         },
//         setToken: (state, action) => {
//             state.token = action.payload;
//             localStorage.setItem('authToken', action.payload);
//             state.isAuthenticated = true;
//         },
//         setLoading: (state, action) => {
//             state.loading = action.payload;
//         },
//         setError: (state, action) => {
//             state.error = action.payload;
//         },
//         logout: (state) => {
//             state.user = null;
//             state.token = null;
//             state.isAuthenticated = false;
//             localStorage.removeItem('authToken');
//         },
//         clearError: (state) => {
//             state.error = null;
//         },
//     },
// });

// export const { setUser, setToken, setLoading, setError, logout, clearError } = authSlice.actions;
// export default authSlice.reducer;
import { createSlice } from '@reduxjs/toolkit';

const getStoredJSON = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

const initialState = {
  user: getStoredJSON('authUser', null),
  token: localStorage.getItem('authToken') || null,
  permissions: getStoredJSON('authPermissions', {}),
  isAuthenticated: !!localStorage.getItem('authToken'),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('authUser', JSON.stringify(action.payload));
      state.isAuthenticated = true;
    },

    setToken: (state, action) => {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem('authToken', action.payload);
        state.isAuthenticated = true;
      } else {
        localStorage.removeItem('authToken');
        state.isAuthenticated = false;
      }
    },

    setPermissions: (state, action) => {
      state.permissions = action.payload || {};
      localStorage.setItem(
        'authPermissions',
        JSON.stringify(action.payload || {})
      );
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    logout: (state) => {
      state.user = null;
      state.token = null;
      state.permissions = {};
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;

      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      localStorage.removeItem('authPermissions');
    },

    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setUser,
  setToken,
  setPermissions,
  setLoading,
  setError,
  logout,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;